import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, isLastItem, StateConfigContext, useBreakpoint } from '@airtel/air-design-system';
import { useContext } from 'react';
import { View } from 'react-native';
import { getSchedulingSlotListStyles } from './SchedulingSlotListStyles';
export var SchedulingSlotList = props => {
  var _a;
  var onSelectSlot = props.onSelectSlot,
    selectedCarousel = props.selectedCarousel;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var schedulingSlotListStyles = getSchedulingSlotListStyles(isLargeScreen);
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  return _jsx(_Fragment, {
    children: !!((_a = selectedCarousel === null || selectedCarousel === void 0 ? void 0 : selectedCarousel.slotList) === null || _a === void 0 ? void 0 : _a.length) && _jsx(View, Object.assign({
      style: schedulingSlotListStyles.container
    }, {
      children: selectedCarousel.slotList.map((slot, index) => {
        return _jsx(Badge, {
          style: [schedulingSlotListStyles.singleSlotItem, !isLastItem(selectedCarousel === null || selectedCarousel === void 0 ? void 0 : selectedCarousel.slotList, index) && schedulingSlotListStyles.singleSlotItemBottomSpacing],
          label: slot === null || slot === void 0 ? void 0 : slot.title,
          isSelected: slot === null || slot === void 0 ? void 0 : slot.isSelected,
          onPress: () => onSelectSlot(slot, index),
          disabled: slot === null || slot === void 0 ? void 0 : slot.isDisabled,
          theme: theme
        }, (slot === null || slot === void 0 ? void 0 : slot.title) + "_" + index);
      })
    }))
  });
};